import { Component, OnInit } from "@angular/core";
import { BlogLanding } from "src/app/models/blog-landing";
import { BlogPost } from "../../../models/blog-post";
import { BlogService } from "../../../services/blog.service";

@Component({
  selector: "app-blog-list",
  templateUrl: "./blog-list.component.html",
  styleUrls: ["./blog-list.component.sass"],
})
export class BlogListComponent implements OnInit {
  header: BlogLanding = null;
  posts: BlogPost[] = [];
  currentPage = 1;
  totalPages = 1;

  constructor(private blogService: BlogService) {}

  ngOnInit(): void {
    this.loadPosts();
    this.getHeader();
  }

  loadPosts(): void {
    this.blogService.getPosts(this.currentPage, 12).subscribe((response) => {
      this.posts = response.data;
      this.totalPages = response.meta.pagination?.pageCount || 1;

      // Extract unique author IDs
      const authorIds = [
        ...new Set(
          this.posts.map((post) => post.author?.id).filter((id) => id != null),
        ),
      ];

      if (authorIds.length > 0) {
        this.blogService.getAuthorsByIds(authorIds).subscribe((authors) => {
          // Map authors to posts
          const authorMap = new Map(authors.map((a) => [a.id, a]));
          this.posts.forEach((post) => {
            if (post.author?.id) {
              post.author = authorMap.get(post.author.id);
            }
          });
        });
      }
    });
  }

  getHeader(): void {
    this.blogService.getBlogLanding().subscribe((response) => {
      this.header = response.data;
    });
  }

  getImageUrl(url: string): string {
    return this.blogService.getImageUrl(url);
  }
}
